import { Icon } from '@iconify/react';
import Card from '../../../../../components/organisms/Card';
import useOnclickOutside from 'react-cool-onclickoutside';
import { delay } from '../../../../../utils/functions';

interface CopyrightInfoCardProps {
  onClose?: () => void;
}

export default function CopyrightInfoCard({ onClose }: CopyrightInfoCardProps) {
  const ref = useOnclickOutside(
    async () => {
      // the delay is a trick to make the copyright text button onClick run before the onClose function. This way, we can make sure it doesn't attempt to
      // reopen the info card when our outside click happens to be on the text button.
      await delay(0);
      onClose?.();
    },
    { eventTypes: ['mouseup'] }
  );

  return (
    <Card className="copyright-image-info" innerRef={ref}>
      <Icon onClick={onClose} className="icon" icon="basil:cross-outline" width="2rem" height="2rem" />
      <p>When picking what image to use for your skill it is important that you know what you are allowed to use.</p>
      <p>The following websites offer free to use stack photos:</p>
      <ul>
        <ol>
          <a target="_blank" rel="noreferrer" href="https://unsplash.com/">
            Unplash.com
          </a>
        </ol>
        <ol>
          <a target="_blank" rel="noreferrer" href="https://www.pexels.com/">
            Pexels.com
          </a>
        </ol>
        <ol>
          <a target="_blank" rel="noreferrer" href="https://pixabay.com/">
            Pixabay.com
          </a>
        </ol>
        <ol>
          <a target="_blank" rel="noreferrer" href="https://gratisography.com/">
            Gratisography.com
          </a>
        </ol>
      </ul>
    </Card>
  );
}
